module.exports = __webpack_public_path__ + "static/media/11.203cda4f.jpg";